import React from "react";
import { Currency } from "types";

type CurrencyContextValue = {
  currency: Currency;
  changeCurrency: (currency: Currency) => void;
};

const CurrencyContext = React.createContext<CurrencyContextValue>({
  currency: Currency.Eth,
  changeCurrency: () => {},
});

export default CurrencyContext;
